import { combineEpics } from 'redux-observable';

import addToCart from './addToCart';
import checkoutContacts from './checkoutContacts';
import checkoutOrder from './checkoutOrder';
import fetchLanguage from './fetchLanguage';
import placeOrder from './placeOrder';
import submitContact from './submitContact';
import setCartDetails from './setCartDetails';
import upgradeAccount from './upgradeAccount';
import macLicenses from './macLicenses';
import macConfigUser from './macConfigUser';
import macEditDetails from './macEditDetails';
import macLicenseEvaluation from './macLicenseEvaluation';
import macOrders from './macOrders';
import macPaymentDetails from './macPaymentDetails';
import macUpdateCreditCard from './macUpdateCreditCard';

export const epic = combineEpics(
  addToCart,
  checkoutContacts,
  checkoutOrder,
  fetchLanguage,
  placeOrder,
  submitContact,
  setCartDetails,
  upgradeAccount,
  macLicenses,
  macConfigUser,
  macEditDetails,
  macLicenseEvaluation,
  macOrders,
  macPaymentDetails,
  macUpdateCreditCard,
);
